import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { MarketShopInventoryItem } from '@/models'
import { resetQueries } from '@/utils/api'

import { GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY } from './get-market-shop-inventory'

export type CreateMarketShopProductRequest = {
  buildingId: number
  categoryId?: number | null
  description: string
  image: string | null
  price: number
  quantity: number
  summary: string
  tags: {
    tagId: number
    discount?: number
  }[]
  unlimited: boolean
  tax: number
}

export const createMarketShopProduct = async (data: CreateMarketShopProductRequest) => {
  const response = await authAPI.post<MarketShopInventoryItem>(`/market-shop/product`, data)
  return response.data
}

export const useCreateMarketShopProduct = () => {
  return useMutation({
    mutationFn: createMarketShopProduct,
    onSuccess: () => {
      resetQueries([GET_MARKET_SHOP_INVENTORY_BASE_QUERY_KEY])
    },
  })
}
